import React from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import CheckoutList from './checkoutList';
import {allowNumericWithdecimal, convertTwoDecimalPoint} from '../../../server/util'
const styles={
    miniTextBox:{
        height: '25px',
        margin: '3px',
        padding: '3px',
        fontSize: '12px'
    }
}
class Events extends React.Component{
    constructor(props){
        super(props);
        this.state={
            eventList:this.props.eventList,
            schoolObject:this.props.schoolObject,
            checkOutObject:{}
        }
    }
    componentWillReceiveProps=(nextProps)=>{
        this.setState({eventList:nextProps.eventList,schoolObject:nextProps.schoolObject})
    }
    checkoutClick=(e,record)=>{
        let _event=this.state.checkOutObject;
        let _rec=JSON.parse(JSON.stringify(record));
        const list=_rec.studentList.filter(st=>{
            return st.isSelected===true && parseFloat(convertTwoDecimalPoint(st.amount))>0
        });        
        if(list.length>0){
            _rec.studentList=list||[];
            _event[_rec.recId]=_rec;
            this.setState({checkOutObject:_event})
        }else{
            delete _event[_rec.recId];
            this.setState({checkOutObject:_event})
        }
            
    }
    getColumns=()=>{
        return([
            {
                id: 'eventName',
                Cell: (props) => {
                    const eventType=props.original.type;
                    const isDonation=eventType==='Donation'?true:false;
                    return(
                        <div className="row">
                            <div className="col-md-9">
                            <div className="row">
                                <div className="col-md-12 color-3">{props.original.eventName}</div>
                                <div className="col-md-12">
                                {
                                    (props.original.studentList||[]).map((item,k)=>{
                                        return(<div key={k} className="row">
                                            <div className="col-md-5">
                                                <div className="checkbox">
                                                    <label>
                                                        <input type="checkbox" checked={item.isSelected} onChange={(e)=>{
                                                            let _events=this.state.eventList;
                                                            _events[props.index].studentList[k].isSelected=e.target.checked?true:false;
                                                            this.setState({eventList:_events});
                                                        }} /> {item.lastName+', '+item.firstName}
                                                    </label>
                                                </div>  
                                            </div>
                                            <div className="col-md-2">
                                                <input className="form-control" disabled={!isDonation}
                                                value={item.amount} 
                                                onKeyPress={(e)=>{allowNumericWithdecimal(e)}} onKeyUp={(e)=>{allowNumericWithdecimal(e)}} onBlur={(e)=>{allowNumericWithdecimal(e)}}
                                                style={styles.miniTextBox} type="text" onChange={(e)=>{
                                                    let _events=this.state.eventList;
                                                    _events[props.index].studentList[k].amount=e.target.value;
                                                    this.setState({eventList:_events});
                                                }} />
                                            </div>
                                        </div>)
                                    })
                                }
                                </div>
                            </div>
                            </div>
                            <div className="col-md-3">
                                <button className="btn btn-xs btn-success" onClick={(e)=>{
                                    this.checkoutClick(e,props.original)
                                }}><i className="fa fa-cart-plus"></i> Add to Cart</button></div>
                        </div>
                    )
                }
            }
        ])
    }
    render(){
        return(
            <div className="row">
                <div className="col-md-8">
                    <div class="panel panel-primary">
                        <div class="panel-heading">
                            <h3 class="panel-title">{'Events'}</h3>
                        </div>
                        <div class="panel-body">
                            <ReactTable
                            columns={this.getColumns()}
                            data={this.state.eventList} 
                            minRows={0}
                            showPagination= {false} />
                        </div>
                    </div>
                </div>
                <div className="col-md-4">
                    <CheckoutList checkOutData={this.state.checkOutObject} 
                    schoolObject={this.state.schoolObject}
                    onDeleteCartItem={(id)=>{
                        let _checkoutObj=this.state.checkOutObject;
                        delete _checkoutObj[id];
                        this.setState({checkOutObject:_checkoutObj})
                    }}
                    onPaymentDone={(resp)=>{ 
                        this.props.onPaymentDone(resp)                       
                    }}
                    showHideLoading={(value)=>{
                        this.props.showHideLoading(value)
                    }}
                     />
                </div>
            </div>
        )}
}
export default Events


// WEBPACK FOOTER //
// ./src/components/Parent/eventSlider/events.jsx